export default __webpack_public_path__ + "static/media/full_screen_editor.b5c705e8.svg";